// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"0fddda08","421":"3982674a"}[chunkId] + ".js";
};